import { Icon, IconButton, Icons } from '@silverfort/sf-components';
import moment from 'moment';
import { FC, useCallback, useEffect, useState } from 'react';
import { useGetLastSync } from '../../api/queries/useGetLastSync';

export const LastSyncBanner: FC = () => {
    const [show, setShow] = useState(false);

    const { lastSync } = useGetLastSync();

    useEffect(() => {
        if (lastSync) setShow(true);
    }, [lastSync]);

    const close = useCallback(() => {
        setShow(false);
    }, []);

    return show ? (
        <div className="p-4 bg-sf-primary-50 border-b border-solid border-sf-primary-500 w-full h-12 flex justify-between items-center grow">
            <span className="flex gap-1 items-center">
                <Icon className="text-sf-primary-500" icon={Icons.Sync} size={16} />
                <span className="text-12 font-medium">Last applications & services imported from API sync</span>
                <span className="text-12 font-medium text-sf-gray-500">{moment.utc(lastSync).fromNow()}</span>
            </span>

            <IconButton icon={Icons.Cancel} onClick={close} />
        </div>
    ) : null;
};
